export default __webpack_public_path__ + "static/media/xp.6b56d1b5.svg";